import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam, NzUploadFile, NzUploadModule, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { delay, of, take } from 'rxjs';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';
import { FileService } from './../../core/file/file.service';

@Component({
  selector: 'app-upload-files',
  standalone: true,
  imports: [CommonModule, FormsModule, NzButtonModule, NzIconModule, NzUploadModule, BasicPageComponent],
  templateUrl: './upload-files.component.html',
  styleUrl: './upload-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFilesComponent {
  constructor(
    private fileService: FileService,
    private msg: NzMessageService
  ) {}

  async uploadFileToS3(signedUrl: string) {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;

    console.log('-----fileInput:', fileInput.files);

    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];

      console.log('-----file.type:', file.type);
      try {
        const response = await fetch(signedUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type, // Ensure the content type matches the file's MIME type
          },
        });

        if (response.ok) {
          console.log('File uploaded successfully');
        } else {
          console.error('Failed to upload file', response.statusText);
        }
      } catch (error) {
        console.error('Error uploading file', error);
      }
    } else {
      console.error('No file selected');
    }
  }

  onS3SignedUrlClick() {
    this.fileService
      .getPresignedUrlToUpload$('upload_test.png')
      .pipe(take(1))
      .subscribe((data) => {
        // this._url = data?.url;
      });
  }

  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;

    console.log('-----handleChange:', status);
    if (status !== 'uploading') {
      // console.log(file, fileList);
    }
    if (status === 'done') {
      this.msg.success(`${file.name} file uploaded successfully.`);

      console.log('----- fileList:', fileList);

      fileList = fileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = (file.originFileObj as any)?.url ?? '';
        }
        return file;
      });
    } else if (status === 'error') {
      this.msg.error(`${file.name} file upload failed.`);
    }
  }

  uploadFileHandler = (item: NzUploadXHRArgs) => {
    console.log('-----item:', item);
    return of(true)
      .pipe(delay(1000), take(1))
      .subscribe(() => {
        if (item.onSuccess) {
          console.log('-----file:', item.file);
          console.log('-----file:', item.postFile);

          item.file.url = 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png';

          item.onSuccess!(
            'Success',
            item.file as NzUploadFile,
            'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
          );
        }
      });
  };
}
